<div class="confirmation-step">
  @if (isLoading) {
    <lh-shared-ui-spinner [visible]="true"></lh-shared-ui-spinner>
  } @else {
    <lh-shared-feature-bookings-storage-room-access-info
      [booking]="booking"
      [storageLocation]="storageLocation"
      [hideAccessText]="true"
    ></lh-shared-feature-bookings-storage-room-access-info>

    @if (properties.showLuggageImage && !storageLocation?.isSelfService) {
      <lh-shared-feature-bag-image-input
        [isTakingPhoto]="false"
        [numberOfBags]="numberOfBags"
        [remoteLuggageImage]="remoteLuggageImage"
        [localLuggageImage]="localLuggageImage"
        [storageLocation]="storageLocation"
      ></lh-shared-feature-bag-image-input>
    }

    @if (properties.showStorageTimer) {
      <lh-shared-feature-bookings-timer
        [booking]="booking"
        [isCheckInSession]="true"
      ></lh-shared-feature-bookings-timer>
    }
  }
</div>
